export default "__VITE_ASSET__4ZdIXnF8__"